import React from 'react';
import styles from './RateSummarySnapshotMetrics.module.scss';
import classNames from 'classnames';
import {RateSummaryMetric} from 'typing/dto';

interface RateSummarySnapshotMetricsProps {
    metrics: RateSummaryMetric[];
}

interface RateSummaryMetricCardProps {
    title: string;
    type: 'currency' | 'percentage' | 'string';
    comparison: string;
    value: string | number;
    change?: {
        value: number;
        isPositive: boolean;
    };
    status?: 'negative' | 'positive' | '';
    subtitle?: string;
}

const RateSummarySnapshotMetricsCard: React.FC<RateSummaryMetricCardProps> = ({
    title,
    value,
    type,
    comparison,
    change,
    status,
    subtitle
}) => {
    const formattedValue = type === 'currency' ? 
        `$${value}` : 
        type === 'percentage' ? 
            `${value}%` : 
            value;

    return (
        <div className={classNames(styles.card, styles[status || ''])}>
            <h3 className={styles.title}>{title}</h3>
            <div className={styles.value}>
                {formattedValue}
                {change && (
                    <span className={classNames(styles.change, change.isPositive ? styles.positive : styles.negative)}>
                        {change.isPositive ? '+' : '-'}{change.value}%
                    </span>
                )}
            </div>
            {comparison && <p className={styles.comparison}>vs. {comparison}</p>}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
    );
};

export const RateSummarySnapshotMetrics: React.FC<RateSummarySnapshotMetricsProps> = (props) => {
    return (
        <div className={styles.metrics}>
            <RateSummarySnapshotMetricsCard 
                title="Health Score"
                type="string"
                comparison=""
                value={props.metrics[0].value}
                change={props.metrics[0].change}
                status={props.metrics[0].status}
                subtitle={props.metrics[0].subtitle}
            />
            <RateSummarySnapshotMetricsCard 
                title="Ytd Revenue"
                type="currency"
                comparison="Last Year"
                value={props.metrics[1].value}
                change={props.metrics[1].change}
                status={props.metrics[1].status}
                subtitle={props.metrics[1].subtitle}
            />
            <RateSummarySnapshotMetricsCard 
                title="Avg Daily Rate"
                type="currency"
                comparison="Market Average"
                value={props.metrics[2].value}
                change={props.metrics[2].change}
                status={props.metrics[2].status}
                subtitle={props.metrics[2].subtitle}
            />
            <RateSummarySnapshotMetricsCard 
                title="Occupancy Rate"
                type="percentage"
                comparison="Market Average"
                value={props.metrics[3].value}
                change={props.metrics[3].change}
                status={props.metrics[3].status}
                subtitle={props.metrics[3].subtitle}
            />
        </div>
    );
}; 